import request from "../utils/request";

export function batchList() {
  return request.get(`/api/enrollPortalHebic/v1/score/batchList`);
}

export function queryEnroll(examNumber, credenNumber) {
  return request.post(`/api/enrollPortalHebic/v1/score/result`, {
    examNumber,
    credenNumber,
  });
}
